import { type ReactNode, type PropsWithChildren } from 'react'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import ChevronIcon from '../icons/ChevronIcon'

type DropdownSubPropTypes = {
  trigger: ReactNode
} & PropsWithChildren

const DropdownSub = ({ trigger, children }: DropdownSubPropTypes) => {
  return (
    <DropdownMenu.Sub>
      <DropdownMenu.SubTrigger className="group flex w-full justify-between items-center text-sm text-white rounded-[5px] px-[10px] py-[7px] outline-none cursor-default data-[highlighted]:bg-gray-700">
        {trigger}
        <ChevronIcon className="w-2 h-2 -rotate-90" />
      </DropdownMenu.SubTrigger>
      <DropdownMenu.Portal>
        <DropdownMenu.SubContent className="z-50 w-56 rounded-[5px] bg-gray-900 shadow-lg focus:outline-none p-[5px] flex gap-[5px] flex-col mt-[-5px] animate-dropdown">
          {children}
        </DropdownMenu.SubContent>
      </DropdownMenu.Portal>
    </DropdownMenu.Sub>
  )
}

export default DropdownSub
